import React from "react";
import {SaveGamesWidgetHeaderBox} from "./boxes/save-games-widget-header.box";
import {observer} from "mobx-react";
import {withServices} from "../../../react-hooks/with-services";
import {ComponentServicesPick} from "../../../services/component-services-pick";
import {useServices} from "../../../react-hooks/use-services.hook";

interface SaveGamesWidgetHeaderComponentProps extends ComponentServicesPick<'userMenu'> {
}

const ComponentBody: React.FC<SaveGamesWidgetHeaderComponentProps> = observer((props) => {

        const services = useServices();

        const _onClick = () => {
                services.games.showAllSavedGamesDrawer();
                props.userMenu.closeMenu();
        };

        const RightArrowIcon = services.theme.currentTheme.icons.rightArrowIcon;
        const SavedGamesIcon = services.theme.currentTheme.icons.saveGameIcon;

        return (
            <SaveGamesWidgetHeaderBox className={"cy-save-games-widget-header"} ref={props.userMenu.saveWidgetRef}>
                <span>
                    <SavedGamesIcon size={2}/>
                </span>
                <span>
                    {services.translation.translate("MY_SAVED_GAMES")}
                </span>
                <span onClick={() => _onClick()}>
                    {services.translation.translate("ALL")}
                    <RightArrowIcon size={1.5}/>
                </span>
            </SaveGamesWidgetHeaderBox>
        );
});

export const SaveGamesWidgetHeaderComponent = withServices(ComponentBody, ["userMenu"]);